export enum IntegrationKey {
  Famous = "famous",
  Plaid = "plaid",
  Payments = "payments",
  OracleFusion = "oracle-fusion",
  OracleEbs = "oracle-ebs",
  Jira = "jira",
  MicrosoftTeams = "microsoft-teams",
  VoiceAgent = "voice-agent",
  Slack = "slack",
}
